module.exports = "/images/addImage.svg?bdaefb5a928006e1e717b88231b86de3";